/**
 * CRA / shop: remap dead https://assets.rainbow-sails.shop/ URLs to REACT_APP_ASSETS_DEAD_HOST_REPLACE_WITH
 * (same idea as dashboard getAssetUrl; keep env naming identical across dashboard + frontend).
 */

const DEAD_HOST = 'assets.rainbow-sails.shop';

export function rewriteLegacyShopAssetUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const origin = String(process.env.REACT_APP_ASSETS_DEAD_HOST_REPLACE_WITH || '')
    .trim()
    .replace(/\/+$/, '');
  if (!origin) return url;
  try {
    const u = new URL(url);
    if (u.hostname !== DEAD_HOST) return url;
    const tail = `${u.pathname}${u.search}${u.hash}`;
    return `${origin}${tail}`;
  } catch (_) {
    return url;
  }
}
